import Header from 'shared/components/modal/header/header';

import styles from './header-mobile.styl';


export default function (props) {
  return (
    <Header {...props}
            className={styles.header}
            titleClassName={styles.title}
            buttonClassName={styles['close-button']}
            showHelpLink={false} />
  );
}



// WEBPACK FOOTER //
// ./src/shared/components/modal/header/header-mobile.js